// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"460":"cf922d23","891":"d8cc60e0"}[chunkId] + ".chunk.js";
};